<template>
  <div>
    <div class="el-card__header card-header__wrap">
      <span class="card-header--title">
        <create-traceinfo-btn
          :envInfoType="envInfoType"
          :envName="envName"
          :fetch="fetchList" />
      </span>
      <div class="card-header--form">
        <el-input
          v-model="config.envInfoName"
          :placeholder="'请输入' + envName + '名称'"
          style="width: 200px">
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="handleCurrentChange(1)"></el-button>
        </el-input>
      </div>
    </div>
    <el-table
      border
      :data="list">
      <el-table-column
        :label="envName + '名称'"
        :resizable="false"
        el-pagination
        width="240">
        <template slot-scope="{row}">
          <link-route :link-to="`${typeMap[envInfoType]}?vendorId=${row.vendorId}&envInfoId=${row.envInfoId}`">
            {{ row.envInfoName }}
          </link-route>
        </template>
      </el-table-column>
      <el-table-column
        label="图片"
        :resizable="false"
        el-pagination>
        <template slot-scope="{row}">
          <image-list :list="row.envImageList" />
        </template>
      </el-table-column>
      <el-table-column
        label="创建时间"
        :resizable="false"
        el-pagination
        width="140">
        <template slot-scope="{row}">
          {{ row.createdTime | dateformat() }}
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        :resizable="false"
        el-pagination
        width="80">
        <template slot-scope="{row}">
          <el-button
            type="danger"
            @click="deletetracingenvinfo(row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination-new
      v-model="config"
      :total="total"
      :fetch="fetchList" />
  </div>
</template>

<script>
import ImageList from '@/components/image-list.vue'
import CreateTraceinfoBtn from './busi/create-traceinfo-btn.vue'
import { mapState } from 'vuex'
export default {
  name: 'TraceInfoList',
  components: { ImageList, CreateTraceinfoBtn },
  props: {
    envInfoType: {
      type: Number,
      default: 1
    },
    envName: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      loading: false,
      config: {
        pageNum: 1,
        pageSize: 10,
        envInfoName: '',
        vendorId: null
      },
      list: [],
      total: 0,
      typeMap: {
        1: '/plat-env-detail',
        2: '/breed-env-detail',
        3: '/work-env-detail'
      }
    }
  },
  computed: {
    ...mapState({
      query: state => state.common.query
    })
  },
  created() {
    if (this.query) {
      this.config = {
        ...this.config,
        ...this.query
      }
    }
  },
  activated() {
    this.fetchList()
  },
  mounted() {
    this.fetchList()
  },
  methods: {
    handleCurrentChange(current) {
      this.config.pageNum = current
      this.fetchList()
    },
    fetchList() {
      this.loading = true
      this.$store.commit('common/setQuery', this.config)
      this.$store.dispatch('traceinfo/gettracingenvinfos', {
        payload: {
          ...this.config,
          envInfoType: this.envInfoType
        },
        success: (res) => {
          this.loading = false
          this.total = res.data.total
          this.list = res.data.records.map(item => {
            item.envImageList = item.envImage.split(',')
            item.envImage = item.envImage.split(',').map(o => ({ url: o }))
            return item
          })
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    deletetracingenvinfo(row) {
      this.$confirm(`此操作将永久删除该${this.envName}, 是否继续?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.loading = true
          this.$store.dispatch('traceinfo/deletetracingenvinfo', {
            payload: {
              envInfoId: row.envInfoId,
              vendorId: row.vendorId
            },
            success: () => {
              this.loading = false
              this.fetchList()
            },
            fail: () => {
              this.loading = false
            }
          })
        })
    }
  }
}
</script>
